import { get, post } from './http'

let baseUrl = window.g.baseUrl

// 会员登录 /pwdLogin
export function login (params) {
  return get(`${baseUrl}/pwdLogin`, params)
}

// 获取公司信息 /companyInfo
export function companyInfo (params) {
  return get(`${baseUrl}/companyInfo`, params)
}

// 获取首页轮播图 /getPcBannerList
export function getPcBannerList (params) {
  return get(`${baseUrl}/getPcBannerList`, params)
}

// 获取推荐课程信息 /getRecommendAndExtendCourse
export function getRecommendAndExtendCourse (params) {
  return get(`${baseUrl}/getRecommendAndExtendCourse`, params)
}

// 获取全部分类 /getIndustryItemRelation
export function getIndustryItemRelation (params) {
  return get(`${baseUrl}/getIndustryItemRelation`, params)
}

// 获取资讯列表 getCompanyArticle
export function getCompanyArticle (params) {
  return get(`${baseUrl}/getCompanyArticle`, params)
}

// 我的课程 getMyCourseList
export function getMyCourseList (params) {
  return get(`${baseUrl}/getMyCourseList`, params)
}

// 获取练习题三方地址 thirdTopicIndex
export function thirdTopicIndex (params) {
  return get(`${baseUrl}/thirdTopicIndex`, params)
}

// 获取考试第三方地址 thirdExamIndex
export function thirdExamIndex (params) {
  return get(`${baseUrl}/thirdExamIndex`, params)
}

// 课程详情 courseDetail
export function courseDetail (params) {
  return get(`${baseUrl}/courseDetail`, params)
}

// 获取课程播放地址 thirdVideoIndex
export function thirdVideoIndex (params) {
  return get(`${baseUrl}/thirdVideoIndex`, params)
}

// 修改密码 changePWD
export function changePWD (params) {
  return get(`${baseUrl}/changePWD`, params)
}

// 获取验证码 getVerificationCode
export function getVerificationCode (params) {
  return get(`${baseUrl}/getVerificationCode`, params)
}

// 验证码登录 phoneCodeLogin
export function phoneCodeLogin (params) {
  return get(`${baseUrl}/phoneCodeLogin`, params)
}

// 重置密码 resetPassword
export function resetPassword (params) {
  return post(`${baseUrl}/user/resetPassword`, params)
}

// 新用户注册 registerUserInfo
export function registerUserInfo (params) {
  return post(`${baseUrl}/user/registerUserInfo`, params)
}